import PageTitle from "@/components/PageTitle";
import SideBarWrapper from "@/components/SideBarWrapper";
import { FileSpreadsheet } from "lucide-react";
import { Listing } from "./Listing";

const Reports = () => {

  return (
    <SideBarWrapper>
      <div className="LookUpTabs">
        <div className="content-lookups xl:p-5 p-3 w-[80vw]">
          <>
            <div>
              <div className="card mb-5 p-3">
                <PageTitle icon={FileSpreadsheet} pageTitle="Reports" />
              </div>
              <Listing />
            </div>
          </>
        </div>
      </div>
    </SideBarWrapper>
  );
};

export default Reports;
